import { useMemo } from "react";

import { Bar } from "react-chartjs-2";

import { useUser } from "@components/user-context";
import { Badge, Spinner } from "@components/v2";
import { BackgroundPlugin } from "@features/orders-v2/chart-plugins/background-plugin";

import { useUniversalBenchmarksConfiguratorContext } from "../hooks";

import {
  generateChartData,
  generateChartDataset,
  getChartOptions,
} from "./utils";

export const Chart = () => {
  const { user } = useUser();

  const { isBaselineDaysLoading, daysSelection } =
    useUniversalBenchmarksConfiguratorContext();

  const chartDataset = useMemo(() => {
    const chartData = generateChartData({
      rows: daysSelection,
      timezone: user.timezone,
    });
    return generateChartDataset(chartData);
  }, [daysSelection, user.timezone]);

  return (
    <div className="h-full flex flex-col">
      <h3 className="text-lg font-semibold mb-2 flex items-center gap-2">
        Profitability Benchmarks
        <Badge variant="alert" className="border-v2-beta">
          Beta
        </Badge>
      </h3>
      <div className="pr-2 flex-1 flex flex-col overflow-hidden">
        {isBaselineDaysLoading ? (
          <div className="flex items-center justify-center h-full">
            <Spinner className="text-cosmic" />
          </div>
        ) : (
          <>
            <div className="overflow-hidden h-full">
              <Bar
                datasetIdKey="id"
                options={getChartOptions({
                  code: user.currencies.currentCurrency,
                })}
                data={chartDataset}
                plugins={[BackgroundPlugin]}
              />
            </div>
            <div className="text-2xs text-center pb-2">Revenue by day</div>
          </>
        )}
      </div>
    </div>
  );
};
